<template>
  <li class="smart-list__item inline-block">
    <p
      v-if="label"
      role="heading" aria-level="3" class="text-opacity-md font-medium font-size-default">
      {{ label }}
    </p>
    <p
      v-if="$slots.default"
      role="text" class="font-medium font-size-default">
      <slot />
    </p>
  </li>
</template>

<script>
export default {
  name: 'SmartListItem',
  props: {
    label: {
      type: String,
      default: null
    }
  }
};
</script>
